import { useCallback } from 'react'

import usePageConfig from 'Pods/Shared/Hooks/usePageConfig'
import { openSignInModal } from 'Pods/ThreeDStudio/Store/actions/ui'

// Guards account-only actions (uploads) on /ai. Returns a callback that prompts
// a logged-out user to sign up and reports whether the caller may proceed.
function useRequireLogin() {
  const { isCurrentUser: isLoggedIn } = usePageConfig() || {}

  return useCallback(() => {
    if (isLoggedIn) {
      return true
    }
    openSignInModal('signup')

    return false
  }, [isLoggedIn])
}

export default useRequireLogin
